<template>
<div v-if="isInitial">
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="content-wrapper" v-bind:class="{ modal_open: modalActive }">
      <div class="container">
        <article>
          <section id="isInitial" class="section white-panel pr0 mb2p">
            <div class="mr16" v-if="this.inspectionDetailStore.detail[0].status_code === 1 || this.inspectionDetailStore.detail[0].status_code === 2">
              <h2 class="text-center fs18 font-weight-bold">お見積り金額(税込)</h2>
              <p class="text-center fs32 line-height1 font-weight-bold mb28">{{ $filters.addComma(this.inspectionDetailStore.detail[0].estimate_price) }}<span class="ml4 fs20 va-middle">円</span></p>
            </div>
            <div class="mr16" v-if="this.inspectionDetailStore.detail[0].status_code === 3">
              <h2 class="text-center fs18 font-weight-bold">確定見積り金額(税込)</h2>
              <p class="text-center fs32 line-height1 font-weight-bold mb28">{{ $filters.addComma(this.inspectionDetailStore.detail[0].before_maintenance_price) }}<span class="ml4 fs20 va-middle">円</span></p>
            </div>
            <div class="mr16" v-if="this.inspectionDetailStore.detail[0].status_code === 4 || this.inspectionDetailStore.detail[0].status_code === 5">
              <h2 class="text-center fs18 font-weight-bold">精算金額(税込)</h2>
              <p class="text-center fs32 line-height1 font-weight-bold mb28">{{ $filters.addComma(this.inspectionDetailStore.detail[0].payment_price) }}<span class="ml4 fs20 va-middle">円</span></p>
            </div>

            <div class="mb20">
              <dl class="dl dl-l dl-fs16 dt65-dd35 dl-bottom-line dl-toggle">
                <dt class="color-font2">法定費用</dt>
                <dd class="color-font1">{{ $filters.addComma(this.inspectionDetailStore.detail[0].inspection_price.weight_tax + this.inspectionDetailStore.detail[0].inspection_price.cali_fee + this.inspectionDetailStore.detail[0].inspection_price.revenue_stamp_fee) }}円</dd>
                <dd class="child pl8">
                  <dl class="dl dl-m dl-fs14 dt65-dd35">
                    <dt class="color-font2">重量税</dt>
                    <dd class="color-font1">{{ $filters.addComma(this.inspectionDetailStore.detail[0].inspection_price.weight_tax) }}円</dd>
                    <dt class="color-font2">自賠責保険24ヶ月</dt>
                    <dd class="color-font1">{{ $filters.addComma(this.inspectionDetailStore.detail[0].inspection_price.cali_fee) }}円</dd>
                    <dt class="color-font2">収入印紙</dt>
                    <dd class="color-font1">{{ $filters.addComma(this.inspectionDetailStore.detail[0].inspection_price.revenue_stamp_fee) }}円</dd>
                  </dl>
                </dd>
              </dl>
              <dl class="dl dl-l dl-fs16 dt65-dd35 dl-bottom-line dl-toggle">
                <dt class="color-font2">車検基本料+定額整備費用</dt>
                <dd class="color-font1">{{ $filters.addComma(this.inspectionDetailStore.detail[0].inspection_price.base_price + this.inspectionDetailStore.detail[0].inspection_price.oil_exchanged_fee) }}円</dd>
                <dd class="child pl8">
                  <dl class="dl dl-m dl-fs14 dt65-dd35">
                    <dt class="color-font2">車検基本料＋定額整備費用</dt>
                    <dd class="color-font1">{{ $filters.addComma(this.inspectionDetailStore.detail[0].inspection_price.base_price) }}円</dd>
                    <dt class="color-font2" v-if="this.inspectionDetailStore.detail[0].inspection_price.oil_exchanged_fee !== 0">エンジンオイル{{ $filters.oilExchanged(this.inspectionDetailStore.detail[0].inspection_price.oil_exchanged_fee) }}</dt>
                    <dd class="color-red2" v-if="this.inspectionDetailStore.detail[0].inspection_price.oil_exchanged_fee !== 0">{{ $filters.addComma(this.inspectionDetailStore.detail[0].inspection_price.oil_exchanged_fee) }}円</dd>
                  </dl>
                </dd>
              </dl>
              <dl v-if="this.inspectionDetailStore.detail[0].inspection_price.coupon_fee !== null" class="dl dl-l dl-fs16 dt65-dd35 dl-bottom-line pr10p">
                <dt class="color-font2">クーポン</dt>
                <dd class="color-red2">{{ $filters.addComma(this.inspectionDetailStore.detail[0].inspection_price.coupon_fee) }}円</dd>
              </dl>
              <div v-if="this.inspectionDetailStore.detail[0].inspection_additional_expense.length > 0">
                <dl class="dl dl-l dl-fs16 dt65-dd35 dl-bottom-line pr10p">
                  <dt class="color-font2">追加の発生費用</dt>
                  <dd class="color-font1">{{ $filters.addComma(additionPrice) }}円</dd>
                </dl>
              </div>
              <dl class="dl dl-l dl-fs16 dt65-dd35 dl-bottom-line pr10p">
                <dt class="color-font2">（うち消費税</dt>
                <dd class="color-font1">{{ $filters.addComma($filters.roundDown(taxPrice)) }}円）</dd>
              </dl>
            </div>

            <div class="bg-gray1 pd12 mr16 mb8" v-if="this.inspectionDetailStore.detail[0].status_code === 1 || this.inspectionDetailStore.detail[0].status_code === 2">
              <p class="mb0 color-font2">上記は「お見積りのクルマ情報」に記載の車両についてのみ有効です。お持ちいただいた車両が記載情報と異なる場合、店頭で金額を修正させて頂く場合があります。<br>
              タイヤ交換が発生する場合は、別途、店頭でお好きな商品をご購入ください。</p>
            </div>
            <div class="bg-gray1 pd12 mr16 mb8" v-if="this.inspectionDetailStore.detail[0].status_code === 3">
              <p class="mb0 color-font2">整備中に追加で整備が必要な個所が見つかり、上記の金額に追加で整備費用がかかる場合があります。ご了承ください。</p>
            </div>
            <p class="fs14"><a id="legalFee" v-on:click='modalOpen($event)' class="color-green2">法定費用について</a></p>
            <p class="fs14"><a id="basicFee" v-on:click='modalOpen($event)' class="color-green2">車検基本料+定額整備費用について</a></p>
          </section>
          <div v-if="this.inspectionDetailStore.detail[0].status_code === 1 || this.inspectionDetailStore.detail[0].status_code === 2">
            <section class="section white-panel">
              <h2 class="text-center fs18 font-weight-bold">追加で発生する可能性のある費用</h2>
              <p class="text-center fs14 font-weight-bold color-red2 mb16">店頭で検査後にご案内いたします</p>
              <dl class="dl dl-l dl-fs16 dt65-dd35 mb20">
                <dt class="color-font2">タイヤ交換</dt>
                <dd class="color-font1 mb4">-円</dd>
                <dt class="color-font2">タイミングベルト交換</dt>
                <dd class="color-font1 mb4">-円</dd>
                <dt class="color-font2">定額対象外部品の交換</dt>
                <dd class="color-font1 mb4">-円</dd>
              </dl>
              <p class="fs14 mb20"><a id="exchangeSeason" v-on:click='modalOpen($event)' class="color-green2">交換時期の目安</a></p>
            </section>
          </div>
          <div v-if="this.inspectionDetailStore.detail[0].status_code === 3 || (this.inspectionDetailStore.detail[0].status_code === 4 && this.inspectionDetailStore.detail[0].inspection_additional_expense.length > 0) || (this.inspectionDetailStore.detail[0].status_code === 5 && this.inspectionDetailStore.detail[0].inspection_additional_expense.length > 0)">
            <section class="section white-panel mb2p">
              <h2 class="text-center fs18 font-weight-bold mb16">追加の発生費用</h2>
                <dl class="dl dl-l dl-fs16 dt65-dd35 mb20">
                  <template v-for="item in this.inspectionDetailStore.detail[0].inspection_additional_expense">
                    <dt class="color-font2">{{ item.contents }}</dt>
                    <dd class="color-font1 mb4">{{ $filters.addComma(item.price) }}円</dd>
                  </template>
              </dl>

              <div class="bg-gray1 pd12 mr16 mb8" v-if="this.inspectionDetailStore.detail[0].status_code === 3">
                <p class="mb0 color-font2">バンパー、ドアミラー、フロントガラスなど定額対象外の整備が発生し追加の整備費用がかかることがあります。定額整備部品の一覧や交換基準については<a v-on:click="toAgreement()" class="color-green2">こちら</a>を御覧ください。</p>
              </div>
            </section>
          </div>
          <section class="section white-panel">
            <h2 class="text-center fs18 font-weight-bold mb16">お見積りのクルマ情報</h2>
            <dl class="dl dl-l dl-fs16 dt50-dd50 mb8">
                <dt class="color-font2">車検満了日</dt>
                <dd class="color-font1">{{ expiryOnWareki.gengo }}{{ $filters.checkFirstYear(expiryOnWareki.year) }}年{{ expiryOnWareki.month }}月{{ expiryOnWareki.date }}日</dd>
                <dt class="color-font2">初度登録年月</dt>
                <dd class="color-font1">{{ firstRegistrationOnWareki.gengo }}{{ $filters.checkFirstYear(firstRegistrationOnWareki.year) }}年{{ firstRegistrationOnWareki.month }}月</dd>
                <dt class="color-font2">自動車の種別</dt>
                <dd class="color-font1">{{ carType.name }}</dd>
                <dt class="color-font2">車名(メーカー)</dt>
                <dd class="color-font1">{{ Manufacturer.manufacturer_name }}</dd>
                <dt class="color-font2">車両重量</dt>
                <dd class="color-font1">{{ $filters.addComma(this.inspectionDetailStore.detail[0].inspection_estimate.weight) }}kg</dd>
                <dt class="color-font2">走行距離</dt>
                <dd class="color-font1">{{ this.mileageWordSet(this.inspectionDetailStore.detail[0].inspection_estimate.mileage)}}</dd>
            </dl>
          </section>
        </article>
      </div>
      <div class="modal_overlay">
        <div class="modal_container">
          <div class="modal_body radius8 pd24 mt8p mb8p">
            <div v-if="aboutLegal">
              <h2 class="fs18 mb8">法定費用について</h2>
              <p class="fs14 mb16">法律に基づき必ず発生する費用になります。<br>
                ・自賠責保険料：法律で車検更新時に必ず加入することが義務付けられている強制保険です。※お客様が任意で加入する任意保険とは別です。<br>
                ・重量税：自動車の重量に応じて納める税金です。エコカー減税により減額される場合もございます。詳細は店頭にてお伝えいたします。<br>
              ・印紙代：車検適合証発行の為に国に支払う費用です。</p>
            </div>
            <div v-if="aboutBasic">
              <h2 class="fs18 mb8">車検基本料＋定額整備費用</h2>
              <p class="fs14 mb16">法定24ヶ月点検の検査費用と、検査後に整備が必要となった30種類以上の定額整備対象部品の部品代金・工賃を含む費用になります</p>
            </div>
            <div v-if="aboutExchange">
              <h2 class="fs18 mb8">交換時期の目安</h2>
              <p class="fs14 mb16">タイヤについては、走行距離3万km、残溝1.6mm以下を目安に交換をおすすめしております。店頭での検査の上、交換を希望する場合はお好きな商品を別途お買い求めください。<br>
              タイミングベルトについては、走行距離10万km、10年以上を目安に交換をおすすめしております。</p>
            </div>
            <button v-on:click="modalClose()" class="button fs16 w100p mt16 mb0 pd16 radius200">閉じる</button>
          </div>
          <!-- /.modal_body -->
        </div>
        <!-- /.modal_container -->
      </div>
    <!-- カーケアTOPに戻るボタン -->
    <form name="fm">
      <input id="tsid" type="hidden" name="tsid" v-bind:value="this.nativeDataStore.nativeData.tsid">
      <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="this.nativeDataStore.nativeData.popinfoid">
      <input id="otoken" type="hidden" name="otoken" v-bind:value="this.nativeDataStore.nativeData.otoken">
      <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="this.versionDataStore.versionData.appVersion">
      <input id="x_cls_os" type="hidden" name="platform" v-bind:value="this.versionDataStore.versionData.platform">
      <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="this.versionDataStore.versionData.osVersion">
    </form>

    </div>
  </div>
  <div v-else-if="isAgreement">
    <a id="isAgreement" v-on:click="toInitial()"></a>
    <Agreement></Agreement>
  </div>
</template>

<script>
import carTypeApi from '@/store/Api/cartype'
import manufacturersApi from '@/store/Api/manufacturers'
import Agreement from '@/views/v3/Agreement.vue'
import Loading from '@/views/v3/Loading.vue'
import modal from '@/assets/v3/modal'
import { useInspectionDetailStore } from '@/store/inspectionDetail'
import { useNativeDataStore } from '@/store/nativeData'
import { useVersionDataStore } from '@/store/versionData'

const IS_INITIAL = 'IS_INITIAL'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  computed: {
    additionPrice: function () {
      let price = 0
      const count = this.inspectionDetailStore.detail[0].inspection_additional_expense.length
      for (let i = 0; i < count; i++) {
        price += Number(this.inspectionDetailStore.detail[0].inspection_additional_expense[i].price)
      }
      return price
    },
    taxPrice: function () {
      // 車検基本料＋定額整備費用＋クーポン料金
      let price = (this.inspectionDetailStore.detail[0].inspection_price.base_price + this.inspectionDetailStore.detail[0].inspection_price.oil_exchanged_fee + this.inspectionDetailStore.detail[0].inspection_price.coupon_fee)
      // 追加発生費用
      price = price + this.additionPrice
      // 消費税率を掛ける
      price = Math.round(price * Number(this.inspectionDetailStore.detail[0].inspection_estimate.tax) * 10)
      price = price / 10
      // 1 + 消費税率を割る
      price = Math.round(price / (1 + Number(this.inspectionDetailStore.detail[0].inspection_estimate.tax)) * 10)
      price = price / 10
      return price
    },
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    },
    inspectionDetailStore: function () {
      return useInspectionDetailStore()
    },
    nativeDataStore: function () {
      return useNativeDataStore()
    },
    versionDataStore: function () {
      return useVersionDataStore()
    }
  },
  methods: {
    modalOpen (about) {
      window.modalHeight = window.pageYOffset
      if (about.target.id === 'legalFee') {
        this.nativeEVENTSet('MitsumoriSyosaiButton', 'MOVED_HOUTEI', 'TAP')
        this.aboutLegal = true
      } else if (about.target.id === 'basicFee') {
        this.nativeEVENTSet('MitsumoriSyosaiButton', 'MOVED_KIHONRYOU', 'TAP')
        this.aboutBasic = true
      } else if (about.target.id === 'exchangeSeason') {
        this.nativeEVENTSet('MitsumoriSyosaiButton', 'MOVED_MEYASU', 'TAP')
        this.aboutExchange = true
      }
      window.scrollTo(0, 0)
      this.modalActive = true
    },
    modalClose () {
      window.scrollTo(0, window.modalHeight)
      this.aboutLegal = false
      this.aboutBasic = false
      this.aboutExchange = false
      this.modalActive = false
    },
    toInitial () {
      this.currentState = IS_INITIAL
    },
    toAgreement () {
      this.nativeEVENTSet('MitsumoriSyosaiButton', 'MOVED_SHAKEN_KOKANKIJYUN', 'TAP')
      this.currentState = IS_AGREEMENT
    },
    openErrorModal (message) {
      modal.alert(message)
    }
  },
  data () {
    return {
      loading: true,
      modalActive: false,
      aboutLegal: false,
      aboutBasic: false,
      aboutExchange: false,
      expiryOnWareki: {},
      firstRegistrationOnWareki: {},
      carType: {},
      Manufacturer: {},
      additionalAllPrice: '',
      currentState: IS_INITIAL
    }
  },
  async mounted () {
    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    let isApiError = false
    this.nativePVset('SHAKEN_MITSUMORI_DETAIL')
    $('.dl-toggle > .child').hide()
    $('.dl-toggle').click(
      function (l) {
        $(this).toggleClass('open')
        $('.child', this).slideToggle(500)
      })
    // APIから自動車の種別、車名（メーカー）を取得する。
    await carTypeApi.getDetail(this.inspectionDetailStore.detail[0].inspection_estimate.model_code).then(res => {
      this.carType = res.data.car_type
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    await manufacturersApi.getDetail(this.inspectionDetailStore.detail[0].inspection_estimate.manufacturer_id).then(res => {
      this.Manufacturer = res.data.manufacturer
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // 車検満了日、初度登録年月の和暦を取得する。
    this.expiryOnWareki = this.toWareki(this.inspectionDetailStore.detail[0].inspection_estimate.expiry_on)
    this.firstRegistrationOnWareki = this.toWareki(this.inspectionDetailStore.detail[0].inspection_estimate.first_registration_on)
    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Agreement,
    Loading
  }
}

</script>

<style></style>
